import { ReactCountryFlag } from "react-country-flag";
import { Box } from "@mui/material";

const curatedCodes: Record<string, string> = {
	"UK": "GB"
};

const Country = ({ country }: { country: string }) => {
	let curatedCountry = country.toUpperCase();
	if (curatedCountry in curatedCodes) {
		curatedCountry = curatedCodes[curatedCountry];
	}

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				gap: "8px",
			}}
		>
			<ReactCountryFlag
				countryCode={curatedCountry ?? ""}
				svg
				title={country ?? ""}
			/>
			&nbsp;{country}
		</Box>
	);
};

export default Country;
